import { inject, Injectable } from '@angular/core';
import { RequestParams } from '../interfaces/request-params';
import { SiaHttpService } from '../services/http.service';
import { notify } from '../services/notify';

@Injectable({
  providedIn: 'root',
})
export class SiaExternalSourcesApi {
  private api = inject(SiaHttpService);

  private readonly apiController: string = 'external-sources-profiles';

  constructor() {}

  findCompaniesByParams(externalSourceName: string, parameters: any) {
    return this.api.post(
      `${this.apiController}/${externalSourceName}/companies-by-params`,
      parameters,
    );
  }

  createNewProfile(
    externalSourceName: string,
    requestParams: RequestParams,
  ): Promise<any> {
    return this.api
      .post(
        `${this.apiController}/${externalSourceName}/profile`,
        requestParams,
      )
      .catch((err) => {
        notify(err?.error?.detail, 4000, 'error');
        throw err;
      });
  }

  updateProfile(
    externalSourceName: string,
    profileId: number,
    parameters: RequestParams,
  ): Promise<any> {
    return this.api
      .put(
        `${this.apiController}/${externalSourceName}/profile/${profileId}`,
        parameters,
      )
      .catch((err) => {
        notify(err?.error?.detail, 4000, 'error');
        throw err;
      });
  }

  refreshProfile(externalSourceName: string, profileId: number) {
    return this.api.put(
      `${this.apiController}/${externalSourceName}/refresh-profile/${profileId}`,
      {},
    );
  }

  deleteRelation(
    externalSourceName: string,
    profileId: number,
  ): Promise<boolean> {
    return this.api.delete(
      `${this.apiController}/${externalSourceName}/relation/${profileId}`,
      {},
    );
  }

  getStoredCompanyByProfile(externalSourceName: string, profileId: number) {
    return this.api.get(
      `${this.apiController}/${externalSourceName}/stored-company-by-profile/${profileId}`,
      {},
    );
  }

  getTemplates(externalSourceName: string, countryId: string) {
    return this.api.get(
      `${this.apiController}/${externalSourceName}/templates/${countryId}`,
      {},
    );
  }

  getTemplatesByProfileId(externalSourceName: string, profileId: number) {
    return this.api.get(
      `${this.apiController}/${externalSourceName}/templates-by-profile/${profileId}`,
      {},
    );
  }
  checkSavedFromId(externalSourceName: string, profileId: number) {
    return this.api.get(
      `${this.apiController}/${externalSourceName}/check/${profileId}`,
      {},
    );
  }

  // public full(param: string, profileId: number, nation: string) {
  //   return this.api.post(`open/full/`, { param, profileId, nation });
  // }

  // public advanced(param: string, profileId: number, nation: string) {
  //   return this.api.post(`open/advanced/`, { param, profileId, nation });
  // }

  // public start(param: string, profileId: number, nation: string) {
  //   return this.api.post(`open/start/`, { param, profileId, nation });
  // }

  // public search(param: string, nation: string) {
  //   return this.api.post(`open/search/`, { param, nation });
  // }

  // public riskAdvanced(param: string, profileId: number, nation: string) {
  //   return this.api.post(`open/risk-advanced/`, { param, profileId, nation });
  // }

  // public riskFull(param: string, profileId: number, nation: string) {
  //   return this.api.post(`open/risk-full/`, { param, profileId, nation });
  // }

  // public getRequests(profileId: string) {
  //   return this.api.post(`open/requests/`, { profileId });
  // }

  // public checkVat(vat: string) {
  //   return this.api.post(`open/check/`, { vat });
  // }
  // public associate(profileId: string) {
  //   return this.api.post(`open/associate/`, { profileId });
  // }
  // public vatFromProfileId(profileId: string) {
  //   return this.api.get(`open/vat-from-profile-id/${profileId}`);
  // }
}
